import React from 'react';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { handleSidebarHover, handleSidebarHoverAway } from '../../../util/utility.functions';
import './style.css';

const PackagesIconActive = require('./PackagesIconActive.png');
const PackagesIconInactive = require('./PackagesIconInactive.png');

function PackagesIcon(props) {
  const { active, label } = props;
  const imgSrc = active ? PackagesIconActive : PackagesIconInactive;
  return (
    <Tooltip title={label}>
      <img
        src={imgSrc}
        alt=""
        height="20"
        width="20"
        onMouseOver={(event) => { handleSidebarHover(event, PackagesIconActive); }}
        onFocus={(event) => { handleSidebarHover(event, PackagesIconActive); }}
        onMouseLeave={(event) => { handleSidebarHoverAway(event, active, PackagesIconInactive); }}
      />
    </Tooltip>
  );
}

PackagesIcon.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.bool.isRequired,
};

export default PackagesIcon;
